export const Messages = {
    regeneration: {
        default: "Generating a new keypair will stop clients from sending data until they have retrieved the new key.",
        in_progress: "Key generation in progress. WARNING: this process can take some time, do not close this window.",
        error: "Error regenerating project key, please try again."
    }
}